import React from "react";
import { Lock, LockOpen } from "@mui/icons-material";

/**
 * Get icon for lock widgets
 * @param {object} widget - Full widget object (optional, for accessing current state)
 * @returns {JSX.Element} Icon component
 */
export const getLockIcon = (widget = null) => {
  const status = widget?.items?.$w1?.value;

  const iconProps = {
    style: {
      fontSize: "1.5rem",
      paddingBottom: "2px",
    },
  };

  // Use different icon based on lock state
  if (status === "locked") {
    return <Lock {...iconProps} />;
  } else if (status === "unlocked") {
    return <LockOpen {...iconProps} />;
  } else if (status === "not fully locked") {
    return <LockOpen {...iconProps} />;
  }

  return <Lock {...iconProps} />;
};

export const getLockSubtitle = (widget = null) => {
  if (!widget) return "";

  const status = widget?.items?.$w1?.value;

  if (status === "locked") {
    return "Locked";
  } else if (status === "unlocked") {
    return "Unlocked";
  } else if (status === "not fully locked") {
    return "Not Fully Locked";
  }

  return "Unknown";
};

/**
 * Get patterns that this helper supports
 * @returns {string[]} Array of pattern strings
 */
export const getLockPatterns = () => {
  return ["basic.device.lockUnlock"];
};
